<template>
  <div style='background-color: white;padding: 10px;border-radius: 8px;height: calc(100vh - 132px);overflow-y: hidden'>
    <el-tabs v-model="activeName">
      <el-tab-pane label="品名管理" name="first">
        <searchForm :formOptions='formOptions' @onAdd='onAdd' :btnItems='btnItems' />
        <page-table
          v-if="hardReset"
          v-loading='loading'
          :tableData='tableData'
          :tableLabel='tableLabel'
          :tableOption='tableOption'
          class="gdtable"
          @handleButton='tableBtnHandle(arguments)'
          :isPag='false'
        ></page-table>
      </el-tab-pane>
      <el-tab-pane label="销售单抬头设置" name="second">
        <el-button type="primary" @click='saveTitle' size="mini">保存</el-button>
        <div id='printDiv'>
          <div style='flex: 1;'>
            <div style='width: 100%; font-size: 20px; display: flex; align-items: center; justify-content: center;'>
              <el-input v-model="title" style='width: 200px;' placeholder="请输入内容"></el-input>
              <div style="margin-left: 10px;">产品销售单</div>
            </div>
            <div style='display: flex'>
              <div>收货单位（个人）：深圳市润农科技有限公司</div>
              <div>NO:00000001</div>
            </div>
            <div style='width: 100%;text-align: right;'>
              销售日期：{{ moment(new Date()).format('yyyy年MM月DD日') }}
            </div>
            <div>
              <table style='width: 100%'>
                <thead>
                <tr>
                  <th style='width: 3rem'>序号</th>
                  <th>品名</th>
                  <th>数量(头)</th>
                  <th>重量(KG)</th>
                  <th>单价(元/头)</th>
                  <th>单价(元/KG)</th>
                  <th>标准重(KG/头)</th>
                  <th>金额(元)</th>
                  <th>备注</th>
                </tr>
                </thead>
                <tbody>
                <!-- 在这里添加你的数据渲染逻辑 -->
                <tr v-for='(item,index) in printTableData' :key='index'>
                  <td>{{ item.index }}</td>
                  <td>{{ item.pigBreedType }}</td>
                  <td>{{ item.count }}</td>
                  <td>{{ item.weight }}</td>
                  <td>{{ item.priceNum }}</td>
                  <td>{{ item.priceKg }}</td>
                  <td>{{ item.standardWeight }}</td>
                  <td>{{ item.money }}</td>
                  <td>{{ item.remark }}</td>
                </tr>
                <tr v-if='printTableData.length > 0'>
                  <td colspan="7">合计：</td>
                  <td>{{ calculateTotalAmount() }}</td>
                  <td></td>
                </tr>
                </tbody>
              </table>

            </div>
            <div style='display: flex;width: 80%;margin: auto'>
              <div>客户签名：</div>
              <div>销售部：</div>
              <div>财务：</div>
              <div>制单：</div>
            </div>
          </div>
          <div style="display: flex; align-items: center;">
            <div style="writing-mode: vertical-rl; text-orientation: mixed;">存根（白）财务（红）客户（黄）</div>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>

    <el-dialog
      :title='isAddVisible?"新增":"编辑"'
      :visible.sync='editVisible'
      width='50%'
    >
      <span>品名： </span>
      <el-input style='width: 200px' v-model="edit.name" placeholder="请输入品名"></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="editVisible = false">取 消</el-button>
        <el-button type="primary" @click="add">保 存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import pageTable from '@/components/pageTable'
import searchForm from '@/components/searchForm'
import videoModel from './videoModel'
import login from '../../api/user/login'
import { exportExcel, tranBuildType } from '../../libs/tools'
import store from '../../store'
import VideoPlayer from '../../components/VideoPlayer'
import axios from "axios";
import {getDownload} from "../../libs/axios";
import moment from 'moment/moment'

export default {
  name: 'pigSaleList',
  computed: {
    moment() {
      return moment
    }
  },
  components: {
    pageTable,
    searchForm,
    VideoPlayer,
    videoModel
  },
  data() {
    return {
      loading: true,
      hardReset:true,
      isAddVisible:true,
      totalDevice: 0,
      onlineDevice: 0,
      offlineDevice: 0,
      obj: undefined,
      urlVideo: '',
      editVisible: false,
      btnItems: 'add',
      activeName: 'first',
      printTableData:[
        {index: 1},
        {index: 2},
        {index: 3},
        {index: 4},
        {index: 5},
        {index: 6},
        {index: 7},
      ],
      title: '',
      tableOption: {
        label: '操作',
        options: [
          { label: '编辑', methods: 'edit' , type: 'text' }
        ]
      },
      edit:{
        name: '',
      },
      formOptions: [],
      tableData: [],
      tableLabel: [
        { label: '品名', param: 'name' },
      ],
    }
  },
  mounted() {
    this.getPigSaleList();
    this.getFarmTitle();
  },
  methods: {
    getFarmTitle(){
      this.$http.get(this.$api.getFarmTitle).then(res => {
        this.title = res.result;
      })
    },
    //设备列表
    getPigSaleList(obj) {
      this.$http.get(this.$api.pigBreedTypeList, {
        organizationId: store.state.farmId
      }).then(res => {
        let arr = res.result;
        this.tableData = arr;
        this.loading = false;
        this.hardReset = true;
      })
    },
    tableBtnHandle(arg) {
      if (arg[0] == 'edit') {
        this.editVisible = true;
        this.isAddVisible = false;
        this.edit.name = arg[1].name;
        this.edit.id = arg[1].id;
      }
    },
    saveTitle(){
      this.$http.post(this.$api.setFarmTitle, {
        title: this.title
      }).then(res => {
        this.$message.success('保存成功');
        this.getFarmTitle();
      }).catch(err =>{
        this.$message.error(err.message);
      })
    },
    onAdd() {
      this.isAddVisible = true;
      this.editVisible = true;
      this.edit = {
        name: '',
      };
    },
    calculateTotalAmount() {
      // 计算金额的总计，避免处理空值
      return this.printTableData.reduce((total, item) => {
        const money = parseFloat(item.money);
        return isNaN(money) ? total : total + money;
      }, 0).toFixed(2);
    },
    add(){
      if (this.isAddVisible){
        this.$http.post(this.$api.addPigBreedType, {
          organizationId: store.state.farmId,
          name: this.edit.name
        }).then(res => {
          this.getPigSaleList();
          this.$message.success('新增成功');
          this.editVisible = false;
          this.edit = {
            name: ''
          }
        }).catch(err =>{
          this.$message.error(err.message);
        })
      }else {
        this.$http.post(this.$api.updatePigBreedType, {
          organizationId: store.state.farmId,
          name: this.edit.name,
          id: this.edit.id
        }).then(res => {
          this.getPigSaleList();
          this.$message.success('编辑成功');
          this.editVisible = false;
          this.edit = {
            name: ''
          }
        }).catch(err =>{
          this.$message.error(err.message);
        })
      }
    },
    //重载表格
    loadTable(val) {
      this.hardReset = false
      this.loading = true
      this.getPigSaleList(val)
    },
  }
}
</script>

<style lang="scss" scoped>
::v-deep .gdtable .el-table__body-wrapper {
  height: calc(100vh - 296px) !important;
  overflow-y: auto !important;
}
.title {
  margin-bottom: 10px;
  color: #606266;
}

@page {
  size: auto;
  //margin: 0mm;
}

#printDiv {
  //margin: 20px;
  //padding: 20px;
  //border: 1px solid #000;
  //border-right: 1px solid #000;
  font-size: 12px;
  display: flex;
  width: 100%;
  justify-content: space-between;
}

#printDiv table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 20px;
}

th, td {
  border: 1px solid #000;
  padding: 8px;
  text-align: center;
}

#printDiv th {
  background-color: #f2f2f2;
}

/* Adjustments for the flex container */
#printDiv div[style^="display: flex;"] {
  justify-content: space-between;
}
</style>
